<template>
<div class="popup" v-cloak v-if="changePassShow">
    <div class="content" id="changePass">
        <div class="title" style="border-radius: 9px 9px 0 0;">
            {{$t('language.popup.personalCenter.changePassword')}}
            <div class="icon white-close dialog-close" @click="changePassShow=false"></div>
        </div>
        <div class="personInfo-content">
            <div class="personInfo-column">
                <span> {{$t('language.common.emailAccount')}}</span>
                <span>{{$t('language.common.newPassword')}}</span>
            </div>
            <div class="personInfo-column personInfo-column-msg">
                <p :title="email">{{email}}</p>
                <div class="password-input">
                    <input type="password" ref="newPassword" @blur="passwordVerification()" v-model="newPassword" maxlength="16"/>
                    <div class="password-eye" :class="showPassword?'icon-eye':'icon-eye-hide'" @click="checkShowPassword()"></div>
                </div>
            </div>

            <button class="personInfo-button" @click.stop="changePassword()" :class="newPassword?'':'button-noclick'">{{$t('language.common.save')}}</button>

        </div>
    </div>

</div>
</template>

<script>
import commonstate from '@/js/constant.js';
import commonUtils from "@/js/workspace/common_util.js";
export default {
    data: function () {
        return {
            changePassShow: false,
            email: '',
            userName: '',
            newPassword: '',
            confrimPassWord: '',
            showPassword: false,
        }
    },
    watch: {
        changePassShow(newValue,oldValue){
            if(newValue){
                this.newPassword = '';
                this.showPassword = false;
                this.$refs.newPassword.type = "password";
            }
        }
    },
    created() {
        let user = commonUtils.getUser();
        if(user){
            if(user.loginType&&user.loginType!="sub"&&!(commonstate.activeLoginTypeList.includes(user.loginType))&&!(commonstate.channelTypeList.includes(user.loginType))){
              this.email = user.email.replace("T","");
              this.$refs.newPassword.type = "password";
             }else{
             this.email = user.email
             }
            this.userName = user.username;
        }
    },
    methods: {
        passwordVerification() {
            if (this.newPassword) {
                if (this.newPassword.length > 16 || this.newPassword.length < 8) {
                    this.$toast({
                        text: this.$t('language.login.passwordCharacters'),
                        type: 'fail',
                        idValue: "changePass"
                    });
                    return false;
                }
              
            }
        },
        changePassword() {
            let user = commonUtils.getUser();
            let email=this.email;
            if(user.loginType&&user.loginType!="sub"&&!(commonstate.activeLoginTypeList.includes(user.loginType))&&!(commonstate.channelTypeList.includes(user.loginType))){
                 email = "T"+email;
            }
            let changeData;
             if (this.newPassword) {//如果输入了密码但是密码是空格
                if (!this.newPassword.trim()) {
                    this.$toast({
                        text: this.$t('language.login.passwordCharacters'),
                        type: 'fail',
                        idValue: "changePass"
                    });
                    return false;
                }
            }
            this.newPassword = this.newPassword.replace(/^\s*|\s*$/g, "");
            if (this.newPassword) {
                if (this.newPassword.length > 16 || this.newPassword.length < 8) {
                    this.$toast({
                        text: this.$t('language.login.passwordCharacters'),
                        type: 'fail',
                        idValue: "changePass"
                    });
                    return false;
                }
            }
            if (this.newPassword) {
                changeData = {
                    ud: commonUtils.getUser().id,
                    email: email.trim(),
                    password: this.newPassword.trim(),
                }
            } else {
                changeData = {
                    ud: commonUtils.getUser().id,
                    email: email.trim(),
                }
            }
            this.Utils.doUserHaveLoginRequest("update", changeData).then(res => {
                if (res.status == 200) {
                    commonUtils.refreshUserInfo(this,function(res){});
                    this.$toast({
                        text:  this.$t('language.login.updatedSuccessfully'),
                        type: 'success',
                        idValue: "rightContBan"
                    });
                    this.changePassShow = false;
                } else {
                    if(res.reason&&res.reason=='saltInvalid'){
                    this.$toast({
                        text: this.$t('language.exception.' + res.reason),
                        type: 'fail',
                        idValue: "rightContBan"
                    });
                    }else{
                      this.$toast({
                        text: this.$t('language.popup.remindBindEmail.failed'),
                        type: 'fail',
                        idValue: "rightContBan"
                    });   
                    }
                }

            });
        },
        checkShowPassword(){
            this.showPassword = !this.showPassword;
            if(this.showPassword){
                this.$refs.newPassword.type = "text";
            }else{
                this.$refs.newPassword.type = "password";
            }
        },
    }
}
</script>

<style>
#changePass {
    width: 500px;
    /*no*/
    height: 260px;
    /*no*/
    border-radius: 10px;/*no*/
}

.personInfo-content {
    width: 100%;
    box-sizing: border-box;
    padding: 20px;
    /*no*/
    color: #6f7886;
    font-size: 14px;
    /*no*/
    position: relative;
    display: inline-flex;
}

.personInfo-column {
    display: inline-flex;
    flex-direction: column;
}

.personInfo-column-msg {
    flex: 1;
    padding-left: 20Px;
}

.personInfo-column-msg p{
    margin: 17Px 0;
    padding-left: 10Px;
    word-break: break-word;
}

.personInfo-column span {
    line-height: 50Px;
    color: #000000;
    font-weight: 400;
}

.personInfo-column input {
    margin: 8Px 0;
    border-radius: 6Px;
    font-size: 14px;/*no*/
    font-family: Helvetica;
    line-height: 24px;/*no*/
    color: #6F7886;
}

</style>



// WEBPACK FOOTER //
// src/components/popup/personal_center_popups/change_password_popup.vue